// extracted by mini-css-extract-plugin
export var modal = "Gdpr-module--modal--JL93z";
export var spinAround = "Gdpr-module--spinAround--3aOdK";